import React, { useState } from "react";
import {
  Select,
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneSafari } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import BestTimeToVisit from "../../components/BestTimeToVisit";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiClock, FiSun, FiDollarSign } from "react-icons/fi";
import { FaPaw } from "react-icons/fa";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const safari: any = getOneSafari();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const safari_id = safari?.safari_id;
  const [thumbnail, setThumbnail] = useState<any>(safari?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(safari?.image_cdn_id);
  const [title, setTitle] = useState<any>(safari?.title);
  const [venue, setVenue] = useState<any>(safari?.venue);
  const [openedDays, setOpenedDays] = useState<any>(safari?.opened_days);
  const [openedAt, setOpenedAt] = useState<any>(safari?.opened_at);
  const [closedAt, setClosedAt] = useState<any>(safari?.closed_at);
  const [email, setEmail] = useState<any>(safari?.email_address);
  const [payLink, setPayLink] = useState<any>(safari?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(safari?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(safari?.whatsapp);
  const [facebook, setFacebook] = useState<any>(safari?.facebook);
  const [twitter, setTwitter] = useState<any>(safari?.twitter);
  const [instagram, setInstagram] = useState<any>(safari?.instagram);
  const [youtube, setYoutube] = useState<any>(safari?.youtube);
  const [hashtags, setHashtags] = useState<any>(safari?.hashtag);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    safari?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(safari?.featured);
  const [promoted, setPromoted] = useState<any>(
    safari?.promoted ? safari?.promoted : "no"
  );
  const [safariStatus, setSafariStatus] = useState<any>(safari?.status);
  const [description, setDescription] = useState<any>(safari?.description);
  const [expo, setExpo] = useState<any>(safari?.expo);
  const [showTop, setShowTop] = useState<any>(safari?.show_top);
  const [bestTime, setBestTime] = useState<any>(
    safari?.best_time_to_visit ? safari?.best_time_to_visit : []
  );
  const [pricing, setPricing] = useState<any>(safari?.Pricings);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const safariRoutes = "/data/safari";

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const updateOneSafariHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : safari?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "level",
      venue: venue,
      opened_days: openedDays,
      opened_at: openedAt,
      closed_at: closedAt,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_ad: "none",
      formatted_address: formattedAddress,
      country_short: "none",
      status: safariStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
      show_top: showTop,
      best_time_to_visit: bestTime?.length > 0 ? String(bestTime) : null,
      pricing: pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: safari_id,
      data: data,
      content: _TYPES_.SAFARI,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={safariRoutes}
      eyebrow="DoSee Data • Safari"
      title="Edit Safari"
      subtitle={`Update a safari experience in ${entry_label || "this destination"}.`}
      icon={<FaPaw className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneSafariHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null as any);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Wildlife or landscape photo."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.SAFARI)}
        />
      </AddSection>

      <AddSection
        title="Best Time To Visit"
        hint="Months that are ideal for this safari."
        icon={<FiSun className="h-4 w-4" />}
      >
        <BestTimeToVisit bestTime={bestTime} setBestTime={setBestTime} />
      </AddSection>

      <AddSection title="Safari Details" hint="Title, venue and ranking.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "top",
              title: "Show In Top Safari",
              option: ["no", "yes"],
              preselect:
                showTop !== null && showTop !== undefined
                  ? [{ name: showTop === 0 ? "no" : "yes" }]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setShowTop(0);
                else setShowTop(1);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="Operating days and hours."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <InputField
            props={{
              id: "opened_days",
              title: "Open Days",
              type: "text",
              value: openedDays || "",
              onChange: (e: any) => {
                setOpenedDays(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "opened_at",
              title: "Opened At",
              type: "time",
              value: openedAt || "",
              onChange: (e: any) => {
                setOpenedAt(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "closed_at",
              title: "Closed At",
              type: "time",
              value: closedAt || "",
              onChange: (e: any) => {
                setClosedAt(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <AddSection title="Visibility" hint="Where this entry appears across the site.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
          <Select
            props={{
              id: "safari_status",
              title: "Status",
              option: ["visible", "invisible"],
              preselect:
                safariStatus !== null && safariStatus !== undefined
                  ? [{ name: safariStatus === 1 ? "visible" : "invisible" }]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setSafariStatus(1);
                else setSafariStatus(0);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "featured",
              title: "Featured",
              option: ["no", "yes"],
              preselect:
                featured !== null && featured !== undefined
                  ? [{ name: featured }]
                  : null,
              onChange: (e: any) => {
                setFeatured(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "promoted",
              title: "Promoted",
              option: ["no", "yes"],
              preselect:
                promoted !== null && promoted !== undefined
                  ? [{ name: promoted }]
                  : null,
              onChange: (e: any) => {
                setPromoted(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "gallery",
              title: "Show in Gallery",
              option: ["no", "yes"],
              preselect:
                expo !== null && expo !== undefined
                  ? [{ name: expo === 0 ? "no" : "yes" }]
                  : null,
              onChange: (e: any) => {
                const choice = e.target.value;
                setExpo(choice === "no" ? 0 : 1);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
